/* Roast for the Roar – Landingpage (Präfix rftr-), Stand 12.10.2026.
   Katzen-Umschalter, Taschenlampe, Brüllen, Rezept, Kaffee-Doktor, Spendenzähler, Abo-Konfigurator, Leiste.
   Texte mit Zahlen entstehen hier auf DE/EN (Container mit data-wg-notranslate), alles andere übersetzt Weglot. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.getAttribute('data-init') === '1') return;
    root.setAttribute('data-init', '1');

    var EN = /^en/i.test(document.documentElement.getAttribute('lang') || '') || /^\/en(\/|$)/.test(location.pathname);
    var LOC = EN ? 'en-GB' : 'de-DE';
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function q(s, el) { return (el || root).querySelector(s); }
    function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
    function o(n) { return root.querySelector('[data-rftr-o="' + n + '"]'); }
    function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }
    function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    var D = null;
    try { D = JSON.parse(q('[data-rftr-data]').textContent); } catch (e) { D = null; }
    D = D || {};
    var CUR = D.cur || 'EUR';
    var DE = !D.country || D.country === 'DE';
    var PER_BAG = D.perBag || 250;
    var GIFT_M = D.giftMonths || 12;
    var SHIP = D.ship || { light: 390, heavy: 490, max: 600, from: 4000 };
    var CATS = D.cats || {};
    var Z = D.z || null;

    var fmt = null, fmtE = null, nf0 = null, nf1 = null, dFmt = null, dLong = null, myFmt = null, mFmt = null;
    try { fmt = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR }); } catch (e) {}
    try { fmtE = new Intl.NumberFormat(LOC, { style: 'currency', currency: 'EUR' }); } catch (e) {}
    try { nf0 = new Intl.NumberFormat(LOC, { maximumFractionDigits: 0 }); nf1 = new Intl.NumberFormat(LOC, { maximumFractionDigits: 1 }); } catch (e) {}
    try {
      dFmt = new Intl.DateTimeFormat(LOC, { day: 'numeric', month: 'short' });
      dLong = new Intl.DateTimeFormat(LOC, { day: 'numeric', month: 'long', year: 'numeric' });
      myFmt = new Intl.DateTimeFormat(LOC, { month: 'long', year: 'numeric' });
      mFmt = new Intl.DateTimeFormat(LOC, { month: 'short', year: 'numeric' });
    } catch (e) {}
    function money(c) { var x = Math.round(c) / 100; return fmt ? fmt.format(x) : x.toFixed(2) + ' ' + CUR; }
    function eur(cents) { var x = Math.round(cents) / 100; return fmtE ? fmtE.format(x) : x.toFixed(2).replace('.', ',') + ' €'; }
    function n0(x) { return nf0 ? nf0.format(x) : String(Math.round(x)); }
    function n1(x) { return nf1 ? nf1.format(x) : String(Math.round(x * 10) / 10); }
    function ymDate(s) { var p = String(s || '').split('-'); return new Date(+p[0], (+p[1] || 1) - 1, +p[2] || 1, 12); }
    function fD(d) { return dFmt ? dFmt.format(d) : d.toLocaleDateString(); }

    var T = {
      de: {
        name: { jaguar: 'Jaguar', panther: 'Panther' },
        roast: { jaguar: 'Espresso', panther: 'Filter' },
        size: function (g) { return g >= 1000 ? n1(g / 1000) + ' kg' : g + ' g'; },
        grind: { wb: 'ganze Bohne', em: 'für Siebträger', bl: 'für Herdkanne', hf: 'für Handfilter', fm: 'für Filtermaschine', fp: 'für French Press', cx: 'für Chemex' },
        every: function (w) { return 'alle ' + w + ' Wochen'; },
        cupEsp: 'Espresso', cupFil: 'Tasse (250 ml)', cupHerd: 'Tasse',
        need: function (wk, dose, lab) { return 'Das sind ca. <b>' + n0(wk) + ' g Kaffee pro Woche</b>, gerechnet mit ' + n1(dose) + ' g pro ' + lab + '.'; },
        sug: function (s) { return 'Unser Vorschlag: <b>' + s + '</b>.'; },
        combo: function (q, s, w) { return (q > 1 ? q + ' × ' : '') + s + ' alle ' + w + ' Wochen'; },
        kgOnlyWb: 'Das Kilo gibt es nur als ganze Bohnen. Gemahlen kommt der Kaffee in 250-g-Tüten.',
        title: function (c) { return c + ' im Abo'; },
        titleGift: function (c, m) { return c + ' für ' + m + ' Monate verschenken'; },
        spec: function (q, s, g, w) { return (q > 1 ? q + ' × ' : '') + s + ', ' + g + ', alle ' + w + ' Wochen'; },
        specGift: function (s, g, m) { return s + ', ' + g + ', ' + m + ' Lieferungen, eine pro Monat'; },
        per: 'pro Lieferung', once: 'einmalig',
        was: function (p, pct) { return 'Einzeln wären es ' + p + '.' + (pct ? '<span class="rftr-badge">−' + n0(pct) + ' %</span>' : ''); },
        meta: function (u) { return 'inkl. MwSt., ' + u + ' pro kg'; },
        metaGift: function (p, u) { return 'Das sind ' + p + ' pro Lieferung. Inkl. MwSt., ' + u + ' pro kg'; },
        ship: 'Versand', shipFree: 'kostenlos', shipIncl: 'in Deutschland inklusive', shipOut: 'siehe Kasse',
        shipVal: function (p, f) { return p + ' (ab ' + f + ' kostenlos)'; },
        lan: 'Für Lancaster', lanVal: function (p, y) { return p + ' pro Lieferung, ca. ' + y + ' im Jahr'; }, lanGift: function (p) { return p + ' insgesamt'; },
        cup: 'Pro Tasse', cupVal: function (p) { return 'ca. ' + p; },
        tlCap: 'Voraussichtlicher Versand', tlCapGift: 'Lieferungen',
        tlFirst: 'nächster Werktag', tlCancel: 'danach kündbar',
        giftRange: function (a, b, m) { return m + ' Lieferungen, ' + a + ' bis ' + b; },
        terms: 'Mindestens 3 Lieferungen, danach jederzeit kündbar. Lieferungen verschieben, überspringen und den Rhythmus ändern kannst du in deinem Kundenkonto.',
        termsGift: function (m) { return 'Du zahlst einmal, dann kommt ' + m + ' Monate lang jeden Monat eine Tüte. Trag im Checkout die Adresse der beschenkten Person als Lieferadresse ein.'; },
        cta: 'Abo in den Warenkorb', ctaGift: 'Geschenk in den Warenkorb', adding: 'Kommt in den Warenkorb …',
        failed: 'Das hat nicht geklappt. Wir öffnen die Produktseite.',
        single: function (p, u) { return 'Lieber erst mal eine Tüte? Einzeln kaufen für ' + p + (u ? ' (' + u + ' pro kg)' : ''); },
        noGift: 'Den Panther gibt es gerade nicht als Geschenk-Abo. Wähl den Jaguar oder ein Abo für dich.',
        soldOut: 'Diese Kombination ist gerade ausverkauft. Wähl eine andere Größe oder Mahlung.',
        noPlan: 'Für diese Auswahl gibt es gerade kein Abo.',
        bar: function (p, u) { return 'Abo ab ' + p + (u ? ' (' + u + ' pro kg)' : ''); }, barShort: 'Zum Abo',
        pct: function (p) { return '−' + n0(p) + ' %'; },
        roar: 'Öh. Öh. Öh. Öh. Öh.',
        countMeta: function (n, a, b) { return 'aus ' + n + ' verkauften Tüten, ' + a + ' bis ' + b; },
        bags: function (n) { return n + ' Tüten'; },
        tip: function (m, j, p) { return '<b>' + m + '</b><br>Jaguar: ' + j + '<br>Panther: ' + p; },
        chart: function (n, a, b) { return 'Säulendiagramm: verkaufte Tüten pro Monat von ' + a + ' bis ' + b + ', insgesamt ' + n + '.'; },
        rKaffee: 'Kaffee', rEsp: 'Espresso', rWasser: 'Wasser', rZeit: 'Zeit',
        cupsFor: 'Für', cupsN: function (n) { return n === 1 ? '1 Tasse' : n + ' Tassen'; },
        live: function (c, r) { return c + ' gewählt, ' + r; }
      },
      en: {
        name: { jaguar: 'Jaguar', panther: 'Panther' },
        roast: { jaguar: 'Espresso', panther: 'Filter' },
        size: function (g) { return g >= 1000 ? n1(g / 1000) + ' kg' : g + ' g'; },
        grind: { wb: 'whole bean', em: 'for espresso machine', bl: 'for moka pot', hf: 'for pour-over', fm: 'for filter machine', fp: 'for French press', cx: 'for Chemex' },
        every: function (w) { return 'every ' + w + ' weeks'; },
        cupEsp: 'espresso', cupFil: 'cup (250 ml)', cupHerd: 'cup',
        need: function (wk, dose, lab) { return 'That is about <b>' + n0(wk) + ' g of coffee a week</b>, based on ' + n1(dose) + ' g per ' + lab + '.'; },
        sug: function (s) { return 'Our suggestion: <b>' + s + '</b>.'; },
        combo: function (q, s, w) { return (q > 1 ? q + ' × ' : '') + s + ' every ' + w + ' weeks'; },
        kgOnlyWb: 'The 1 kg bag comes as whole beans only. Ground coffee comes in 250 g bags.',
        title: function (c) { return c + ' subscription'; },
        titleGift: function (c, m) { return c + ' as a ' + m + '-month gift'; },
        spec: function (q, s, g, w) { return (q > 1 ? q + ' × ' : '') + s + ', ' + g + ', every ' + w + ' weeks'; },
        specGift: function (s, g, m) { return s + ', ' + g + ', ' + m + ' deliveries, one a month'; },
        per: 'per delivery', once: 'one-off',
        was: function (p, pct) { return 'Bought one-off it would be ' + p + '.' + (pct ? '<span class="rftr-badge">−' + n0(pct) + '%</span>' : ''); },
        meta: function (u) { return 'incl. VAT, ' + u + ' per kg'; },
        metaGift: function (p, u) { return 'That is ' + p + ' per delivery. Incl. VAT, ' + u + ' per kg'; },
        ship: 'Shipping', shipFree: 'free', shipIncl: 'included in Germany', shipOut: 'see checkout',
        shipVal: function (p, f) { return p + ' (free from ' + f + ')'; },
        lan: 'For Lancaster', lanVal: function (p, y) { return p + ' per delivery, about ' + y + ' a year'; }, lanGift: function (p) { return p + ' in total'; },
        cup: 'Per cup', cupVal: function (p) { return 'about ' + p; },
        tlCap: 'Expected shipping', tlCapGift: 'Deliveries',
        tlFirst: 'next working day', tlCancel: 'cancel any time after',
        giftRange: function (a, b, m) { return m + ' deliveries, ' + a + ' to ' + b; },
        terms: 'Minimum of 3 deliveries, then cancel any time. You can move or skip deliveries and change the rhythm in your account.',
        termsGift: function (m) { return 'Pay once, then a bag arrives every month for ' + m + ' months. Enter the recipient’s address as the delivery address at checkout.'; },
        cta: 'Add subscription to cart', ctaGift: 'Add gift to cart', adding: 'Adding to cart …',
        failed: 'That didn’t work. We’re opening the product page.',
        single: function (p, u) { return 'Just one bag for now? Buy it for ' + p + (u ? ' (' + u + ' per kg)' : ''); },
        noGift: 'The Panther isn’t available as a gift subscription right now. Pick the Jaguar or a subscription for yourself.',
        soldOut: 'This combination is sold out right now. Pick another size or grind.',
        noPlan: 'There is no subscription for this choice right now.',
        bar: function (p, u) { return 'Subscribe from ' + p + (u ? ' (' + u + ' per kg)' : ''); }, barShort: 'Subscribe',
        pct: function (p) { return '−' + n0(p) + '%'; },
        roar: 'Uh. Uh. Uh. Uh. Uh.',
        countMeta: function (n, a, b) { return 'from ' + n + ' bags sold, ' + a + ' to ' + b; },
        bags: function (n) { return n + ' bags'; },
        tip: function (m, j, p) { return '<b>' + m + '</b><br>Jaguar: ' + j + '<br>Panther: ' + p; },
        chart: function (n, a, b) { return 'Column chart: bags sold per month from ' + a + ' to ' + b + ', ' + n + ' in total.'; },
        rKaffee: 'Coffee', rEsp: 'Espresso', rWasser: 'Water', rZeit: 'Time',
        cupsFor: 'For', cupsN: function (n) { return n === 1 ? '1 cup' : n + ' cups'; },
        live: function (c, r) { return c + ' selected, ' + r; }
      }
    };
    var L = EN ? T.en : T.de;
    var live = q('[data-rftr-live]');

    /* ---------- Rezepte aus den Metafeldern ---------- */
    function parseRecipe(s) {
      if (!s) return null;
      var t = String(s).replace(/(\d),(\d)/g, '$1.$2');
      var dose = t.match(/(\d+(?:\.\d+)?)\s*g\w*\s*(?:Kaffee|coffee)/i);
      var out = t.match(/(?:auf|to)\s*(\d+(?:\.\d+)?)\s*g/i) || t.match(/(\d+(?:\.\d+)?)\s*g\w*\s*(?:Wasser|water)/i);
      var sec = t.match(/(\d+)\s*[-–]\s*(\d+)\s*(?:Sek|sec|s\b)/i);
      var min = t.match(/(\d+:\d+|\d+)\s*[-–]\s*(\d+:\d+|\d+)\s*min/i);
      var r = { dose: dose ? +dose[1] : null, water: out ? +out[1] : null, s: sec ? [sec[1], sec[2]] : null, m: min ? [min[1], min[2]] : null };
      if (!r.dose) return null;
      return r;
    }
    var REC = { jaguar: parseRecipe(CATS.jaguar && CATS.jaguar.recipe), panther: parseRecipe(CATS.panther && CATS.panther.recipe) };
    function g1(x) { return n1(x) + ' g'; }
    function renderRecipe(cat, cups) {
      var host = q('[data-rftr-recipe="' + cat + '"]'), R = REC[cat];
      if (!host || !R) return;
      var k = cups || 1, isEsp = cat === 'jaguar';
      var time = R.s ? R.s[0] + '–' + R.s[1] + ' s' : (R.m ? R.m[0] + '–' + R.m[1] + ' min' : '');
      var html = '<span class="rftr-recipe__grid latp-notranslate" data-wg-notranslate>' +
        '<span class="rftr-recipe__cell"><span class="rftr-recipe__k">' + L.rKaffee + '</span><span class="rftr-recipe__v">' + g1(R.dose * k) + '</span></span>' +
        (R.water ? '<span class="rftr-recipe__cell"><span class="rftr-recipe__k">' + (isEsp ? L.rEsp : L.rWasser) + '</span><span class="rftr-recipe__v">' + g1(R.water * k) + '</span></span>' : '') +
        (time ? '<span class="rftr-recipe__cell"><span class="rftr-recipe__k">' + L.rZeit + '</span><span class="rftr-recipe__v">' + esc(time) + '</span></span>' : '') +
        '</span>';
      if (!isEsp && R.water) {
        html += '<span class="rftr-recipe__cups latp-notranslate" data-wg-notranslate role="group">' + L.cupsFor + ' ';
        for (var i = 1; i <= 4; i++) html += '<button type="button" data-rftr-rcups="' + i + '" aria-pressed="' + (i === k ? 'true' : 'false') + '">' + L.cupsN(i) + '</button>';
        html += '</span>';
      }
      host.innerHTML = html;
    }
    renderRecipe('jaguar', 1);
    renderRecipe('panther', 1);

    /* ---------- Produkte, Pläne ---------- */
    function prodFor(cat, who) { var c = CATS[cat]; if (!c) return null; return who === 'gift' ? c.gift : c.main; }
    function hasPlans(pr) {
      return !!(pr && pr.plans && pr.plans.length && pr.v && pr.v.some(function (v) { return v.a && v.sp && Object.keys(v.sp).length; }));
    }
    function giftOk(cat) { return hasPlans(CATS[cat] && CATS[cat].gift); }
    function findV(pr, g, m) {
      if (!pr || !pr.v) return null;
      for (var i = 0; i < pr.v.length; i++) { var v = pr.v[i]; if (v.g === g && v.m === m) return v; }
      return null;
    }
    function weeksOf(pr) {
      var w = (pr && pr.plans || []).filter(function (p) { return p.w > 0; }).map(function (p) { return p.w; });
      return w.filter(function (x, i) { return w.indexOf(x) === i; }).sort(function (a, b) { return a - b; });
    }
    function planW(pr, w) { var ps = (pr && pr.plans) || []; for (var i = 0; i < ps.length; i++) if (ps[i].w === w) return ps[i]; return null; }
    function pctOf(pr) { var m = 0; (pr && pr.plans || []).forEach(function (p) { if (p.pct > m) m = p.pct; }); return m; }
    function grindsOf(pr) { var m = {}; (pr && pr.v || []).forEach(function (v) { if (v.g < 1000) m[v.m] = m[v.m] || v.a; }); return m; }
    function sizesOf(pr) { var s = []; (pr && pr.v || []).forEach(function (v) { if (s.indexOf(v.g) < 0) s.push(v.g); }); return s.sort(function (a, b) { return a - b; }); }
    function shipCost(total, grams) {
      if (!DE) return null;
      if (D.freeShip) return 0;
      if (total >= SHIP.from) return 0;
      return grams <= SHIP.max ? SHIP.light : SHIP.heavy;
    }
    function doseFor(cat, grind) {
      var R = REC[cat] || {};
      if (grind === 'bl') return D.herd || 12;
      if (cat === 'jaguar') return R.dose || 18;
      if (R.dose && R.water) return R.dose * 250 / R.water;
      return 16;
    }
    function cupLabel(cat, grind) { if (grind === 'bl') return L.cupHerd; return cat === 'jaguar' ? L.cupEsp : L.cupFil; }

    /* Abo-Rabatt an den Karten */
    ['jaguar', 'panther'].forEach(function (c) {
      var el = q('[data-rftr-pct="' + c + '"]'), p = pctOf(prodFor(c, 'me'));
      if (el && p > 0) el.textContent = L.pct(p);
    });

    /* ---------- Zustand ---------- */
    var S = { who: 'me', cat: 'jaguar', grind: { jaguar: 'em', panther: 'hf' }, size: 250, qty: 1, w: 3, cups: 2, touched: false, gsize: 250 };
    ['jaguar', 'panther'].forEach(function (c) {
      var gm = grindsOf(prodFor(c, 'me'));
      if (!gm[S.grind[c]]) { var ks = Object.keys(gm); if (ks.length) S.grind[c] = ks.indexOf('wb') >= 0 ? 'wb' : ks[0]; }
    });

    function setCat(c, announce) {
      if (c !== 'jaguar' && c !== 'panther') return;
      S.cat = c;
      root.setAttribute('data-cat', c);
      qa('[data-rftr-set]').forEach(function (b) {
        if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', b.getAttribute('data-rftr-set') === c ? 'true' : 'false');
      });
      try { window.localStorage.setItem('rftr-cat', c); } catch (e) {}
      if (announce && live) live.textContent = L.live(L.name[c], L.roast[c]);
      render();
    }

    /* ---------- Taschenlampe ---------- */
    (function () {
      var box = q('[data-rftr-flash]');
      if (!box) return;
      var used = false, raf = null, t0 = 0, inView = false;
      function setR() { box.style.setProperty('--r', Math.round(clamp(box.clientWidth * 0.2, 70, 150)) + 'px'); }
      function setXY(x, y) { box.style.setProperty('--x', x.toFixed(1) + '%'); box.style.setProperty('--y', y.toFixed(1) + '%'); }
      function fromEv(e) {
        var r = box.getBoundingClientRect();
        setXY(clamp((e.clientX - r.left) / r.width * 100, 0, 100), clamp((e.clientY - r.top) / r.height * 100, 0, 100));
      }
      function mark() { if (!used) { used = true; box.classList.add('is-used'); if (raf) cancelAnimationFrame(raf); } }
      box.addEventListener('pointermove', function (e) { mark(); fromEv(e); });
      box.addEventListener('pointerdown', function (e) { mark(); fromEv(e); });
      var kx = 46, ky = 44;
      box.addEventListener('keydown', function (e) {
        var k = e.key, d = 4;
        if (k === 'ArrowLeft') kx -= d; else if (k === 'ArrowRight') kx += d; else if (k === 'ArrowUp') ky -= d; else if (k === 'ArrowDown') ky += d; else return;
        e.preventDefault(); mark(); kx = clamp(kx, 0, 100); ky = clamp(ky, 0, 100); setXY(kx, ky);
      });
      function loop(ts) {
        if (used || !inView) { raf = null; return; }
        if (!t0) t0 = ts;
        var t = (ts - t0) / 1000;
        setXY(48 + Math.sin(t * 0.8) * 20, 42 + Math.sin(t * 1.25) * 12);
        raf = requestAnimationFrame(loop);
      }
      setR();
      window.addEventListener('resize', setR);
      if (reduce) { setXY(50, 44); return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { inView = en.isIntersecting; if (inView && !used && !raf) raf = requestAnimationFrame(loop); });
        }, { threshold: 0.2 }).observe(box);
      }
    })();

    /* ---------- Brüllen ---------- */
    (function () {
      var btn = q('[data-rftr-roar]'), sec = q('[data-rftr-roar-sec]'), out = q('[data-rftr-roar-out]'), tm = null;
      if (!btn || !sec) return;
      btn.addEventListener('click', function () {
        sec.classList.remove('is-roaring'); void sec.offsetWidth; sec.classList.add('is-roaring');
        if (out) out.textContent = L.roar;
        clearTimeout(tm); tm = setTimeout(function () { sec.classList.remove('is-roaring'); }, 1700);
      });
    })();

    /* ---------- Kaffee-Doktor ---------- */
    (function () {
      var doc = q('[data-rftr-doc]');
      if (!doc) return;
      doc.addEventListener('click', function (e) {
        var b = e.target.closest('[data-doc]'); if (!b) return;
        var k = b.getAttribute('data-doc'), on = b.getAttribute('aria-pressed') !== 'true';
        qa('[data-doc]', doc).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        qa('[data-doc-a]', doc).forEach(function (a) { show(a, false); });
        if (on) { b.setAttribute('aria-pressed', 'true'); show(q('[data-doc-a="' + k + '"]', doc), true); }
      });
    })();

    /* ---------- Video ---------- */
    qa('[data-rftr-video]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-rftr-video'); if (!id) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
        f.title = b.getAttribute('aria-label') || 'YouTube';
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        b.parentNode.replaceChild(f, b);
        f.focus();
      });
    });

    /* ---------- Spendenzähler ---------- */
    (function () {
      if (!Z) return;
      var sec = q('.rftr-count');
      var big = q('[data-rftr-countup]'), chip = q('[data-rftr-sum-chip]'), meta = q('[data-rftr-count-meta]');
      var total = Math.round((Z.betrag != null ? Z.betrag : (Z.tueten || 0) * PER_BAG / 100) * 100);
      if (chip) chip.textContent = eur(total);
      if (big) big.textContent = eur(total);
      var stand = Z.stand ? ymDate(Z.stand) : null, seit = Z.seit ? ymDate(Z.seit) : null;
      if (meta && stand) meta.textContent = L.countMeta(n0(Z.tueten || 0), seit && myFmt ? myFmt.format(seit) : (Z.seit || ''), dLong ? dLong.format(stand) : Z.stand);
      var rj = q('[data-rftr-race="jaguar"]'), rp = q('[data-rftr-race="panther"]');
      if (rj && Z.jaguar != null) rj.textContent = L.bags(n0(Z.jaguar));
      if (rp && Z.panther != null) rp.textContent = L.bags(n0(Z.panther));
      var done = false;
      function count() {
        if (done || !big) return; done = true;
        if (reduce) { big.textContent = eur(total); return; }
        var t0 = 0, dur = 1600;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = clamp((ts - t0) / dur, 0, 1), e = 1 - Math.pow(1 - p, 3);
          big.textContent = eur(p < 1 ? Math.round(total * e / 50) * 50 : total);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (sec && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) { sec.classList.add('is-in'); count(); io.disconnect(); } });
        }, { threshold: 0.25 });
        io.observe(sec);
      } else if (sec) { sec.classList.add('is-in'); }
      drawMonths();
      var rt = null;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(drawMonths, 150); });
    })();

    function drawMonths() {
      var host = q('[data-rftr-months]'), tip = q('[data-rftr-tip]');
      if (!host || !Z || !Z.monate || Z.monate.length < 2) return;
      var M = Z.monate, n = M.length;
      var W = Math.max(280, Math.round(host.clientWidth || 600)), H = Math.max(160, Math.round(host.clientHeight || 220));
      var padL = 34, padR = 4, padT = 10, padB = 28;
      var max = 0; M.forEach(function (m) { max = Math.max(max, (+m[1] || 0) + (+m[2] || 0)); });
      var stepV = max > 150 ? 50 : (max > 60 ? 25 : 10), top = Math.max(stepV, Math.ceil(max / stepV) * stepV);
      var iw = W - padL - padR, ih = H - padT - padB, slot = iw / n, bw = Math.max(3, Math.min(24, slot - 4));
      function y(v) { return padT + ih - (v / top) * ih; }
      var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" role="img" aria-label="' + esc(L.chart(n0(Z.tueten || 0), mFmt ? mFmt.format(ymDate(M[0][0])) : M[0][0], mFmt ? mFmt.format(ymDate(M[n - 1][0])) : M[n - 1][0])) + '">';
      s += '<g class="grid">';
      for (var v = 0; v <= top; v += stepV) {
        var yy = Math.round(y(v)) + 0.5;
        s += '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + yy + '" y2="' + yy + '"></line><text x="' + (padL - 6) + '" y="' + (yy + 4) + '" text-anchor="end">' + n0(v) + '</text>';
      }
      s += '</g>';
      function topPath(x, y0, w, h, r) {
        r = Math.min(r, w / 2, h);
        if (h <= 0) return '';
        return 'M' + x + ' ' + (y0 + h) + 'V' + (y0 + r) + 'Q' + x + ' ' + y0 + ' ' + (x + r) + ' ' + y0 + 'H' + (x + w - r) + 'Q' + (x + w) + ' ' + y0 + ' ' + (x + w) + ' ' + (y0 + r) + 'V' + (y0 + h) + 'Z';
      }
      var lastLab = -1e9;
      M.forEach(function (m, i) {
        var j = +m[1] || 0, p = +m[2] || 0, x = padL + i * slot + (slot - bw) / 2;
        var yj = y(j), hj = y(0) - yj, yp = y(j + p), hp = yj - yp;
        s += '<g class="col" data-i="' + i + '">';
        if (p > 0) {
          if (j > 0) { s += '<rect class="j" x="' + x.toFixed(1) + '" y="' + yj.toFixed(1) + '" width="' + bw.toFixed(1) + '" height="' + hj.toFixed(1) + '"></rect>'; }
          var gap = j > 0 ? 2 : 0;
          s += '<path class="p" d="' + topPath(+x.toFixed(1), +yp.toFixed(1), +bw.toFixed(1), Math.max(0, +(hp - gap).toFixed(1)), 4) + '"></path>';
        } else if (j > 0) {
          s += '<path class="j" d="' + topPath(+x.toFixed(1), +yj.toFixed(1), +bw.toFixed(1), +hj.toFixed(1), 4) + '"></path>';
        }
        s += '<rect class="hit" x="' + (padL + i * slot).toFixed(1) + '" y="' + padT + '" width="' + slot.toFixed(1) + '" height="' + (ih + 4) + '" tabindex="0" focusable="true"></rect>';
        s += '</g>';
        var mm = String(m[0]).split('-')[1];
        if (i === 0 || mm === '01') {
          var lab = i === 0 ? (mFmt ? mFmt.format(ymDate(m[0])) : m[0]) : String(m[0]).split('-')[0];
          var lx = i === 0 ? padL + i * slot + (slot - bw) / 2 : padL + i * slot + slot / 2, lw = lab.length * 7;
          var left = i === 0 ? lx : lx - lw / 2;
          if (left > lastLab + 10) {
            s += '<text x="' + lx.toFixed(1) + '" y="' + (H - 8) + '" text-anchor="' + (i === 0 ? 'start' : 'middle') + '">' + esc(lab) + '</text>';
            lastLab = left + lw;
          }
        }
      });
      s += '</svg>';
      host.innerHTML = s;
      if (!tip) return;
      function hot(i, el) {
        host.classList.add('has-hot');
        qa('.col', host).forEach(function (g) { g.classList.toggle('is-hot', +g.getAttribute('data-i') === i); });
        var m = M[i], hr = host.getBoundingClientRect(), fr = host.parentNode.getBoundingClientRect(), r = el.getBoundingClientRect();
        tip.innerHTML = L.tip(myFmt ? myFmt.format(ymDate(m[0])) : m[0], n0(+m[1] || 0), n0(+m[2] || 0));
        show(tip, true);
        var left = r.left + r.width / 2 - fr.left, topPx = hr.top - fr.top + y((+m[1] || 0) + (+m[2] || 0)) - 8;
        tip.style.left = clamp(left, 70, fr.width - 70) + 'px';
        tip.style.top = Math.max(0, topPx) + 'px';
      }
      function cold() { host.classList.remove('has-hot'); qa('.col', host).forEach(function (g) { g.classList.remove('is-hot'); }); show(tip, false); }
      qa('.hit', host).forEach(function (h) {
        var i = +h.parentNode.getAttribute('data-i');
        h.addEventListener('mouseenter', function () { hot(i, h); });
        h.addEventListener('focus', function () { hot(i, h); });
        h.addEventListener('click', function () { hot(i, h); });
        h.addEventListener('mouseleave', cold);
        h.addEventListener('blur', cold);
      });
    }

    /* ---------- Abo-Konfigurator ---------- */
    var cfg = q('[data-rftr-cfg]');
    function nextWorkday(d) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 12); while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1); return x; }
    function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
    function addMonths(d, n) { var x = new Date(d.getTime()); x.setMonth(x.getMonth() + n); return x; }

    function calc() {
      var cat = S.cat, who = S.who, pr = prodFor(cat, who);
      if (who === 'gift' && !giftOk(cat)) return { err: 'nogift' };
      if (!pr) return { err: 'noplan' };
      var grind = S.grind[cat], size = who === 'gift' ? S.gsize : S.size;
      if (size >= 1000) grind = 'wb';
      var v = findV(pr, size, grind);
      if (!v && size >= 1000) { size = 250; grind = S.grind[cat]; v = findV(pr, size, grind); }
      if (!v) return { err: 'soldout' };
      var plan = null;
      if (who === 'gift') plan = pr.plans && pr.plans[0];
      else { plan = planW(pr, S.w); if (!plan) { var ws = weeksOf(pr); if (ws.length) { S.w = ws.indexOf(3) >= 0 ? 3 : ws[0]; plan = planW(pr, S.w); } } }
      if (!plan || !v.sp || v.sp[String(plan.id)] == null) return { err: 'noplan', v: v, pr: pr };
      if (!v.a) return { err: 'soldout', v: v, pr: pr };
      var qty = who === 'gift' ? 1 : S.qty;
      var unit = v.sp[String(plan.id)];
      var R = { pr: pr, v: v, plan: plan, qty: qty, size: size, grind: grind, unit: unit, reg: v.p, who: who, cat: cat };
      if (who === 'gift') {
        R.total = unit; R.perDel = unit / GIFT_M; R.ship = DE ? 0 : null; R.shipIncl = DE;
        R.lan = GIFT_M * PER_BAG;
        R.kg = unit / (GIFT_M * size) * 1000;
      } else {
        R.total = unit * qty;
        R.ship = shipCost(R.total, qty * size);
        R.lanDel = qty * PER_BAG;
        R.perYear = Math.floor(52 / S.w);
        R.kg = unit / size * 1000;
        R.save = Math.max(0, (v.p - unit) * qty);
        R.pct = plan.pct || (v.p > 0 ? Math.round((v.p - unit) / v.p * 100) : 0);
      }
      var dose = doseFor(cat, grind);
      var cups = (qty * size) / dose;
      if (who === 'gift') cups = size / dose;
      R.cup = cups > 0 ? ((who === 'gift' ? R.perDel : R.total + (R.ship || 0)) / cups) : null;
      return R;
    }

    function suggest() {
      var cat = S.cat, pr = prodFor(cat, 'me'), grind = S.grind[cat];
      if (!pr) return null;
      var need = S.cups * doseFor(cat, grind) * 7, best = null;
      var sizes = sizesOf(pr).filter(function (g) { var v = findV(pr, g, g >= 1000 ? 'wb' : grind); return v && v.a && (g < 1000 || grind === 'wb'); });
      weeksOf(pr).forEach(function (w) {
        var plan = planW(pr, w);
        sizes.forEach(function (g) {
          var v = findV(pr, g, g >= 1000 ? 'wb' : grind);
          if (!v || !plan || !v.sp || v.sp[String(plan.id)] == null) return;
          for (var k = 1; k <= 4; k++) {
            var supply = k * g / w;
            if (supply < need * 0.9) continue;
            var cost = v.sp[String(plan.id)] * k, sh = shipCost(cost, k * g) || 0;
            var c = { g: g, q: k, w: w, supply: supply, weekly: (cost + sh) / w };
            if (!best) { best = c; continue; }
            var sa = Math.round(c.supply), sb = Math.round(best.supply);
            if (sa < sb * 0.97) best = c;
            else if (sa <= sb * 1.03) {
              if (c.weekly < best.weekly - 1) best = c;
              else if (Math.abs(c.weekly - best.weekly) <= 1 && (c.q < best.q || (c.q === best.q && c.w > best.w))) best = c;
            }
          }
        });
      });
      if (!best && sizes.length) {
        var ws = weeksOf(pr), g = sizes[sizes.length - 1];
        best = { g: g, q: 4, w: ws[0] || 2 };
      }
      return { need: need, best: best };
    }

    function pill(attr, val, label, on, dis) {
      return '<button type="button" class="rftr-pill" ' + attr + '="' + val + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (dis ? ' disabled' : '') + '>' + label + '</button>';
    }

    function render() {
      if (!cfg) return;
      var cat = S.cat, who = S.who, gift = who === 'gift', pr = prodFor(cat, who), main = prodFor(cat, 'me');
      qa('[data-rftr-who]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rftr-who') === who ? 'true' : 'false'); });
      /* Mahlung */
      var gm = grindsOf(pr || main);
      qa('[data-rftr-grind]').forEach(function (b) {
        var code = b.getAttribute('data-rftr-grind'), wrap = b.parentNode;
        var mine = wrap.getAttribute('data-only') === cat;
        if (!mine) return;
        b.disabled = !Object.prototype.hasOwnProperty.call(gm, code);
        b.setAttribute('aria-pressed', S.grind[cat] === code ? 'true' : 'false');
      });
      if (!Object.prototype.hasOwnProperty.call(gm, S.grind[cat])) { var ks = Object.keys(gm); if (ks.length) S.grind[cat] = ks.indexOf('wb') >= 0 ? 'wb' : ks[0]; }
      /* Größen */
      var sizes = sizesOf(pr || main), grind = S.grind[cat];
      var curSize = gift ? S.gsize : S.size;
      if (sizes.indexOf(curSize) < 0) curSize = sizes[0] || 250;
      if (curSize >= 1000 && grind !== 'wb') curSize = 250;
      if (gift) S.gsize = curSize; else S.size = curSize;
      var sh = '';
      sizes.forEach(function (g) {
        var v = findV(pr || main, g, g >= 1000 ? 'wb' : grind);
        var dis = !v || !v.a || (g >= 1000 && grind !== 'wb');
        sh += pill('data-rftr-size', g, L.size(g), g === curSize, dis);
      });
      var sizesEl = o('sizes'); if (sizesEl) sizesEl.innerHTML = sh;
      var note = o('grind-note');
      if (note) {
        var kgOnly = sizes.some(function (g) { return g >= 1000; }) && grind !== 'wb';
        note.textContent = kgOnly ? L.kgOnlyWb : ''; show(note, kgOnly);
      }
      /* Menge, Rhythmus */
      show(o('qty-row'), !gift);
      show(o('rhythm'), !gift);
      show(o('calc'), !gift);
      show(o('giftinfo'), gift);
      var ws = weeksOf(main);
      if (ws.indexOf(S.w) < 0 && ws.length) S.w = ws.indexOf(3) >= 0 ? 3 : ws[0];
      var wh = ''; ws.forEach(function (w) { wh += pill('data-rftr-w', w, L.every(w), w === S.w, false); });
      var wEl = o('weeks'); if (wEl) wEl.innerHTML = wh;
      var qEl = o('qty'); if (qEl) qEl.textContent = S.qty;
      var qMinus = q('[data-rftr-qty="-1"]'), qPlus = q('[data-rftr-qty="1"]');
      if (qMinus) qMinus.disabled = S.qty <= 1; if (qPlus) qPlus.disabled = S.qty >= 4;
      var cEl = o('cups'); if (cEl) cEl.textContent = S.cups;
      var cMinus = q('[data-rftr-cups="-1"]'), cPlus = q('[data-rftr-cups="1"]');
      if (cMinus) cMinus.disabled = S.cups <= 1; if (cPlus) cPlus.disabled = S.cups >= 8;
      /* Verbrauch und Vorschlag */
      if (!gift) {
        var sg = suggest(), needEl = o('need'), sugW = o('sug-wrap'), sugEl = o('sug');
        if (sg && needEl) needEl.innerHTML = L.need(sg.need, doseFor(cat, grind), cupLabel(cat, grind));
        if (sg && sg.best) {
          if (!S.touched) {
            S.size = sg.best.g; S.qty = sg.best.q; S.w = sg.best.w;
            if (S.size >= 1000 && grind !== 'wb') S.size = 250;
            if (qEl) qEl.textContent = S.qty;
            qa('[data-rftr-size]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-rftr-size') === S.size ? 'true' : 'false'); });
            qa('[data-rftr-w]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-rftr-w') === S.w ? 'true' : 'false'); });
            if (qMinus) qMinus.disabled = S.qty <= 1; if (qPlus) qPlus.disabled = S.qty >= 4;
          }
          var same = sg.best.g === S.size && sg.best.q === S.qty && sg.best.w === S.w;
          if (sugEl) sugEl.innerHTML = L.sug(L.combo(sg.best.q, L.size(sg.best.g), sg.best.w));
          sugW._sg = sg.best;
          show(sugW, !same);
        } else { show(sugW, false); }
      }
      /* Zusammenfassung */
      var R = calc(), t = o('sum-title'), spec = o('sum-spec'), price = o('price'), per = o('per'), was = o('was'), meta = o('meta'), lines = o('lines'), tl = o('tl'), tlCap = o('tl-cap'), terms = o('terms'), err = o('err');
      var cta = q('[data-rftr-cta]'), single = o('single'), bar = o('bar');
      show(err, false);
      var nm = L.name[cat];
      if (t) t.textContent = gift ? L.titleGift(nm, GIFT_M) : L.title(nm);
      if (R.err) {
        if (spec) spec.textContent = '';
        if (price) price.textContent = '–'; if (per) per.textContent = '';
        show(was, false); if (meta) meta.textContent = ''; if (lines) lines.innerHTML = ''; if (tl) tl.innerHTML = ''; if (tlCap) tlCap.textContent = '';
        if (terms) terms.textContent = R.err === 'nogift' ? L.noGift : (R.err === 'soldout' ? L.soldOut : L.noPlan);
        if (cta) { cta.setAttribute('aria-disabled', 'true'); cta.textContent = gift ? L.ctaGift : L.cta; }
      } else {
        if (cta) { cta.removeAttribute('aria-disabled'); cta.textContent = gift ? L.ctaGift : L.cta; }
        var gtxt = L.grind[R.grind] || '';
        if (spec) spec.textContent = gift ? L.specGift(L.size(R.size), gtxt, GIFT_M) : L.spec(R.qty, L.size(R.size), gtxt, S.w);
        if (price) price.textContent = money(R.total);
        if (per) per.textContent = gift ? L.once : L.per;
        if (!gift && R.reg > R.unit) { was.innerHTML = L.was(money(R.reg * R.qty), R.pct); show(was, true); } else show(was, false);
        if (meta) meta.textContent = gift ? L.metaGift(money(R.perDel), money(R.kg)) : L.meta(money(R.kg));
        var lh = '';
        var shipTxt = gift ? (DE ? L.shipIncl : L.shipOut) : (R.ship == null ? L.shipOut : (R.ship === 0 ? L.shipFree : L.shipVal(money(R.ship), money(SHIP.from))));
        lh += '<dt>' + L.ship + '</dt><dd>' + shipTxt + '</dd>';
        lh += '<dt>' + L.lan + '</dt><dd>' + (gift ? L.lanGift(eur(R.lan)) : L.lanVal(eur(R.lanDel), eur(R.lanDel * R.perYear))) + '</dd>';
        if (R.cup) lh += '<dt>' + L.cup + '</dt><dd>' + L.cupVal(money(R.cup)) + '</dd>';
        if (lines) lines.innerHTML = lh;
        var now = new Date(), first = nextWorkday(now), th = '';
        if (gift) {
          if (tlCap) tlCap.textContent = L.tlCapGift;
          tl.className = 'rftr-tl rftr-tl--one';
          th = '<li class="is-min"><b>' + L.giftRange(mFmt ? mFmt.format(first) : '', mFmt ? mFmt.format(addMonths(first, GIFT_M - 1)) : '', GIFT_M) + '</b></li>';
        } else {
          if (tlCap) tlCap.textContent = L.tlCap;
          tl.className = 'rftr-tl';
          for (var i = 0; i < 4; i++) {
            var d = addDays(first, i * 7 * S.w);
            th += '<li class="' + (i < 3 ? 'is-min' : '') + '"><b>' + fD(d) + '</b>' + (i === 0 ? L.tlFirst : (i === 3 ? L.tlCancel : '')) + '</li>';
          }
        }
        if (tl) tl.innerHTML = th;
        if (terms) terms.textContent = gift ? L.termsGift(GIFT_M) : L.terms;
      }
      /* Einzelkauf */
      var sv = findV(main, 250, S.grind[cat]) || findV(main, 250, 'wb');
      if (single && main) {
        single.href = main.url + (sv ? '?variant=' + sv.id : '');
        single.textContent = sv ? L.single(money(sv.p), sv.g ? money(sv.p / sv.g * 1000) : '') : L.single('');
      }
      /* Leiste */
      if (bar) {
        var minP = null, minG = 0;
        (main && main.v || []).forEach(function (v) { if (v.g === 250 && v.a && v.sp) { Object.keys(v.sp).forEach(function (k) { if (minP == null || v.sp[k] < minP) { minP = v.sp[k]; minG = v.g; } }); } });
        bar.textContent = minP != null && minG && window.innerWidth >= 720 ? L.bar(money(minP), money(minP / minG * 1000)) : L.barShort;
      }
    }

    /* Klicks */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button, a');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-rftr-set')) {
        setCat(b.getAttribute('data-rftr-set'), true);
        return;
      }
      if (b.hasAttribute('data-rftr-who')) { S.who = b.getAttribute('data-rftr-who'); render(); return; }
      if (b.hasAttribute('data-rftr-grind')) { S.grind[S.cat] = b.getAttribute('data-rftr-grind'); render(); return; }
      if (b.hasAttribute('data-rftr-size')) { var g = +b.getAttribute('data-rftr-size'); if (S.who === 'gift') S.gsize = g; else { S.size = g; S.touched = true; } render(); return; }
      if (b.hasAttribute('data-rftr-w')) { S.w = +b.getAttribute('data-rftr-w'); S.touched = true; render(); return; }
      if (b.hasAttribute('data-rftr-qty')) { S.qty = clamp(S.qty + (+b.getAttribute('data-rftr-qty')), 1, 4); S.touched = true; render(); return; }
      if (b.hasAttribute('data-rftr-cups')) { S.cups = clamp(S.cups + (+b.getAttribute('data-rftr-cups')), 1, 8); S.touched = false; render(); return; }
      if (b.hasAttribute('data-rftr-take')) { var sw = o('sug-wrap'); if (sw && sw._sg) { S.touched = false; render(); } return; }
      if (b.hasAttribute('data-rftr-rcups')) { var cc = +b.getAttribute('data-rftr-rcups'); var host = b.closest('[data-rftr-recipe]'); if (host) renderRecipe(host.getAttribute('data-rftr-recipe'), cc); return; }
      if (b.hasAttribute('data-rftr-cta')) { addToCart(b); }
    });

    /* Warenkorb */
    var CART = (/^\/en(\/|$)/.test(location.pathname) ? '/en' : '') + '/cart';
    function addToCart(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var R = calc(); if (!R || R.err) return;
      var fallback = R.pr.url + '?variant=' + R.v.id + '&selling_plan=' + R.plan.id;
      var err = o('err'); show(err, false);
      if (!window.fetch) { location.href = fallback; return; }
      var label = btn.textContent;
      btn.setAttribute('aria-disabled', 'true'); btn.textContent = L.adding;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: R.v.id, quantity: R.qty || 1, selling_plan: R.plan.id }] })
      }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function () { location.href = CART; })
        .catch(function () {
          btn.removeAttribute('aria-disabled'); btn.textContent = label;
          if (err) { err.textContent = L.failed; show(err, true); }
          setTimeout(function () { location.href = fallback; }, 1500);
        });
    }

    /* Kopfhöhe für sticky */
    var hdr = document.querySelector('.shopify-section-header');
    function headerOffset() {
      var px = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
      root.style.setProperty('--top', Math.min(px, 200) + 'px');
    }
    var ticking = false, trail = null;
    function schedule() {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { headerOffset(); ticking = false; }); }
      clearTimeout(trail); trail = setTimeout(headerOffset, 280);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (hdr && window.MutationObserver) new MutationObserver(schedule).observe(hdr, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
    headerOffset();

    /* Leiste unten */
    var barEl = q('[data-rftr-bar]'), hero = q('.rftr-hero'), aboSec = q('.rftr-abo'), outro = q('.rftr-outro');
    var pastHero = false, inAbo = false, inOutro = false;
    function updBar() {
      if (!barEl) return;
      var on = pastHero && !inAbo && !inOutro;
      barEl.classList.toggle('is-on', on);
      barEl.setAttribute('aria-hidden', on ? 'false' : 'true');
      qa('button, a', barEl).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
    }
    if ('IntersectionObserver' in window) {
      if (hero) new IntersectionObserver(function (es) { es.forEach(function (en) { pastHero = !en.isIntersecting && en.boundingClientRect.top < 0; }); updBar(); }).observe(hero);
      if (aboSec) new IntersectionObserver(function (es) { es.forEach(function (en) { inAbo = en.isIntersecting; }); updBar(); }, { threshold: 0.05 }).observe(aboSec);
      if (outro) new IntersectionObserver(function (es) { es.forEach(function (en) { inOutro = en.isIntersecting; }); updBar(); }).observe(outro);
    }

    /* Start: ?katze=panther|jaguar, ?roestung=filter|espresso, ?fuer=geschenk */
    var params = new URLSearchParams(location.search), start = null;
    var pk = (params.get('katze') || params.get('cat') || '').toLowerCase(), pr2 = (params.get('roestung') || params.get('roast') || '').toLowerCase();
    if (pk === 'panther' || pk === 'jaguar') start = pk;
    else if (/filter/.test(pr2)) start = 'panther';
    else if (/espresso/.test(pr2)) start = 'jaguar';
    if (!start) { try { var ls = window.localStorage.getItem('rftr-cat'); if (ls === 'panther' || ls === 'jaguar') start = ls; } catch (e) {} }
    if (/geschenk|gift/.test((params.get('fuer') || params.get('for') || '').toLowerCase())) S.who = 'gift';
    setCat(start || 'jaguar', false);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-rftr]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-rftr]'); if (r) init(r); });
})();
